var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerBox"},[_c('div',{staticClass:"bannerContent"},[_c('div',{staticClass:"bannerInner",style:({ 'background-image': 'url(' + _vm.bannerImg + ')' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }